/**
 * AdminRoute Component
 * Route wrapper that requires admin permissions
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useRBAC } from '../../hooks/useRBAC';
import ProfessionalLoader from "../common/ProfessionalLoader";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { isAdmin, isLoading: rbacLoading } = useRBAC();

  // Show loading spinner while checking authentication and permissions
  if (isLoading || rbacLoading) {
    return (
      <div className="loading-container">
        <ProfessionalLoader size="large" variant="default" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to dashboard if not admin
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Render children if user is authenticated and is admin
  return children;
};

export { AdminRoute };
export default AdminRoute;
